import { render, staticRenderFns } from "./ArtigosPlanWizard.vue?vue&type=template&id=23f180c4&scoped=true&"
import script from "./ArtigosPlanWizard.vue?vue&type=script&lang=js&"
export * from "./ArtigosPlanWizard.vue?vue&type=script&lang=js&"
import style0 from "./ArtigosPlanWizard.vue?vue&type=style&index=0&id=23f180c4&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23f180c4",
  null
  
)

export default component.exports